<template>
  <div id="thank-you" class="container">
    <div class="content-wrapper">
      <div :style="`background-image: url('/assets/images/banner-commande.webp')`" class="image"></div>
      <div class="content">

        <div class="text">
          <div class="text-content">

            <h1 class="sf-heading__title" v-html="$t('thanksOrder')"></h1>
            <p class="order">{{ $t('Order N°:') }}
              <SfLink :link="'/mon-compte/commandes?order='+orderNumber" class="order-link">{{ orderNumber }}</SfLink>
            </p>
            <p class="order-text">{{ $t('order.text') }}</p>
            <div class="order-actions">
              <SfButton class="color-white-bg text-primary-color" link="/"> {{ $t('back to home') }}</SfButton>
              <SfButton :link="'/mon-compte/commandes?order='+orderNumber" class="color-primary">
                {{ $t('Show my order') }}
              </SfButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {SfLink, SfHeading, SfButton} from '@storefront-ui/vue';
import Api from "@/api/Api";
import {Order} from "@/models/order";
import shipmentItem from "@/components/Checkout/ShipmentItem";
import GtagEvent from "@/utils/GtagEvent";

export default {
  components: {
    SfHeading,
    SfLink,
    SfButton,
  },
  data() {
    return {
      orderNumber: null,
      orderId: this.$router.history.current.params.order
    }
  },
  created() {
    this.getOrderNumber();
  },
  methods: {

    getOrderNumber() {

      if (this.orderId) {
        this.$store.dispatch('setCart', null);
      }
      Api.order.getById(this.orderId).then((data) => {
        const order = Order.of(data)
        if(order) {
          this.orderNumber = order.reference
          GtagEvent.purchase(order)

        }

        const items=[];
        order.shipments.forEach(shipment=>{
          shipment.items.forEach(item=>{
           const itemGTA = {
             item_id: item.product.reference,
             item_name :item.product.name,
             item_quantity:item.quantity,
             currency: "EUR",
             price: item.price.taxIncluded,
           }
           items.push(itemGTA)
          })
        })
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({ ecommerce: null });

        window.dataLayer.push({
          event: "purchase",
          ecommerce: {
            transaction_id: order.reference,

            value: order.totalPrice.taxIncluded,
            tax: order.totalPrice.taxAmount,
            shipping: order.shippingPrice.taxIncluded,
            currency: "EUR",
            coupon: order.coupon.name,
            items
          }
        })
        /*
        * dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
dataLayer.push({
  event: "purchase",
  ecommerce: {
      transaction_id: "T_12345",
      affiliation: "Google Merchandise Store",
      value: 25.42,
      tax: 4.90,
      shipping: 5.99,
      currency: "USD",
      coupon: "SUMMER_SALE",
      items: [
       {
        item_id: "SKU_12345",
        item_name: "Stan and Friends Tee",
        affiliation: "Google Merchandise Store",
        coupon: "SUMMER_FUN",
        currency: "USD",
        discount: 2.22,
         price: 9.99,
        index: 0,
        item_brand: "Google",
        item_category: "Apparel",
        item_category2: "Adult",
        item_category3: "Shirts",
        item_category4: "Crew",
        item_category5: "Short sleeve",
        item_list_id: "related_products",
        item_list_name: "Related Products",
        item_variant: "green",
        location_id: "ChIJIQBpAG2ahYAR_6128GcTUEo",
        price: 9.99,
        quantity: 1
      },
      {
        item_id: "SKU_12346",
        item_name: "Google Grey Women's Tee",
        affiliation: "Google Merchandise Store",
        coupon: "SUMMER_FUN",
        currency: "USD",
        discount: 3.33,
        index: 1,
        item_brand: "Google",
        item_category: "Apparel",
        item_category2: "Adult",
        item_category3: "Shirts",
        item_category4: "Crew",
        item_category5: "Short sleeve",
        item_list_id: "related_products",
        item_list_name: "Related Products",
        item_variant: "gray",
        location_id: "ChIJIQBpAG2ahYAR_6128GcTUEo",
        price: 20.99,
        promotion_id: "P_12345",
        promotion_name: "Summer Sale",
        quantity: 1
      }]
  }
});
        * */
      })
          .catch((error) => {

          }).finally(() => {

      })
    }
  }
};
</script>

<style lang="scss" scoped>
#thank-you {
  margin-top: var(--spacer-base);
  box-sizing: border-box;
  @include for-desktop {
    margin-top: var(--spacer-2xl);
  }
}

@include for-mobile {
  .container {
    padding: 0;
  }
}

#alpha {
  position: absolute;
}

.content-wrapper {
  display: flex;
  position: relative;
  align-items: stretch;

  //  background-color: var(--c-primary);
  color: var(--c-primary);
  border-radius: 2px;
  flex-wrap: wrap;
}

.content {
  position: relative;
  padding-bottom: 40%;
  width: 100%;
  flex: 1;
  flex-direction: column;
  display: flex;
  align-self: stretch;
  @include for-desktop-small {
    padding-bottom: 50%;
  }
  @include for-tablet {
    padding-bottom: 0;
  }

  .text {
    position: absolute;
    top: 0;
    right: 0;
    left: 55%;
    bottom: 0;
    padding: var(--spacer-base) var(--spacer-lg);

    background-size: cover;
    background-position: top center;
    @include for-tablet {
      clip-path: none;
      position: relative;
      left: 0;
    }
    @include for-mobile {
      clip-path: none;
      position: relative;
      left: 0;
    }

    &-content {
      margin: auto;
      width: 100%;
      height: 100%;
      flex: 1;
      flex-direction: column;
      display: flex;
      align-self: stretch;
      @include for-tablet {
        width: 100%;
        margin: auto;
      }
      @include for-mobile {
        width: 100%;
        margin: auto;
      }

      ::v-deep {
        .sf-heading__title {

          margin-bottom: var(--spacer-xl);
          @include for-desktop-small{
            margin-bottom: var(--spacer-base);
            margin-top: 0;
          }
          color: var(--c-primary);
          font-weight: 500;
          span {
            font-weight: 500;
            text-transform: none !important;
          }
        }
      }
    }
  }

  .order {
    font-size: var(--font-size--lg);
    text-transform: uppercase;
    font-weight: bold;
    text-align: center;
    margin: 0.5rem 0;
    color: var(--c-text);

    &-link {
      font-size: var(--font-size--lg);
      text-transform: uppercase;
      text-decoration: underline;
    }

    &-text {
      line-height: 1.8rem;
      text-align: center;
      color: var(--c-text);
    }
  }

}

.image {
  border-radius: 2px 0 0 2px;
  z-index: 0;
  position: absolute;
  top: 0;
  right: 45%;
  left: 0;
  bottom: 0;
  background-size: cover;
  background-position: right center;
  margin-right: 0;
  @include for-tablet {
    background-position: center bottom;
    position: relative;
    left: 0;
    right: 0;
    height: 420px;
    width: 100%;
  }
  @include for-mobile {
    position: relative;
    background-position: center bottom;
    left: 0;
    right: 0;
    height: 380px;
    width: 100%;
  }
}

.order-actions {
  margin: var(--spacer-base) 0 0 0;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;

  .sf-button {
    width: auto;
    flex: 40%;
    white-space: nowrap;
    min-height: 42px;
    padding: var(--spacer-sm) var(--spacer-xs);
    margin: var(--spacer-xs);

    &:first-of-type:not(:last-of-type) {
      margin: var(--spacer-sm) var(--spacer-sm) var(--spacer-sm) 0;
    }

    &:last-of-type:not(:first-of-type) {
      margin: var(--spacer-sm) 0 var(--spacer-sm) var(--spacer-sm);
    }

    @include for-mobile {
      flex: 100%;
      &:first-of-type:not(:last-of-type) {
        margin: 0;
        margin-top: var(--spacer-sm);
      }
      &:last-of-type:not(:first-of-type) {
        margin: var(--spacer-sm) 0 0;
      }
    }
  }
}

::v-deep {
  .sf-heading {
    text-align: left;
    margin: 0 0 var(--spacer-xl);

    &__title {
      color: var(--c-primary);
      line-height: 2rem;
      text-align: center;
      margin: var(--spacer-xl) 0 var(--spacer-base);
    }
  }

  .sf-link {
    font-weight: bold;
    color: var(--c-primary);

  }
}

</style>
